import { render, staticRenderFns } from "./aLteAsideNavItemDropdown.vue?vue&type=template&id=f26b46dc"
import script from "./aLteAsideNavItemDropdown.vue?vue&type=script&lang=js"
export * from "./aLteAsideNavItemDropdown.vue?vue&type=script&lang=js"
import style0 from "./aLteAsideNavItemDropdown.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f26b46dc', component.options)
    } else {
      api.reload('f26b46dc', component.options)
    }
    module.hot.accept("./aLteAsideNavItemDropdown.vue?vue&type=template&id=f26b46dc", function () {
      api.rerender('f26b46dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideNavItemDropdown.vue"
export default component.exports